<div
  class="relative w-full h-full overflow-y-auto overflow-x-hidden"
  style="padding: 8px 8px 0px 8px"
  #mainDom
>
  @if (attachStickers.length > 0) {
    <livery-attach-sticker-list
      [attachStickers]="attachStickers"
      (editorStickerIndex)="onEditAttachSticker($event)"
    ></livery-attach-sticker-list>
  }

  <p class="text-xs lg:text-base text-white font-semibold mb-1 lg:mb-2">Create Sticker</p>
  <div class="relative w-full flex flex-row">
    <button
      class="w-full px-2 lg:px-4 py-1 lg:py-2 text-[0.625rem] lg:text-xs border border-r-0 rounded-l text-black"
      [ngClass]="{
        'bg-white': selectedMakeStickerTypeIndex === 0,
        'bg-slate-300 dark:bg-black dark:text-white': selectedMakeStickerTypeIndex !== 0,
      }"
      (click)="selectedMakeStickerTypeIndex = 0"
    >
      Upload
    </button>
    <button
      class="w-full px-2 lg:px-4 py-1 lg:py-2 text-[0.625rem] lg:text-xs border rounded-r text-black"
      [ngClass]="{
        'bg-white': selectedMakeStickerTypeIndex === 1,
        'bg-slate-300 dark:bg-black dark:text-white': selectedMakeStickerTypeIndex !== 1,
      }"
      (click)="selectedMakeStickerTypeIndex = 1"
    >
      AI Maker
    </button>
  </div>
  <mat-tab-group class="py-2 mb-1 lg:mb-2" [selectedIndex]="selectedMakeStickerTypeIndex">
    <mat-tab label="Upload">
      <div
        class="flex flex-col gap-3 justify-center items-center border lg:border-2 border-slate-400 border-dashed rounded p-3"
        style="width: 100%; aspect-ratio: 1 / 0.75"
        [ngStyle]="{ aspectRatio: width > 300 ? '1 / 0.4' : '1 / 0.75' }"
        [ngClass]="{
          'border-slate-100 bg-slate-600': isDragOver,
          'border-slate-400 ': !isDragOver,
        }"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragOut($event)"
        (drop)="onDrop($event)"
      >
        <p class="text-[9.5px] lg:text-[12.5px] dark:text-white text-center">
          Drag and drop an image file or click the upload button to add a sticker
        </p>
        <button
          class="px-1.5 lg:px-3 py-0.5 lg:py-1 rounded bg-sky-700 text-white text-[10px] lg:text-sm"
          (click)="stickerUpload.click()"
        >
          Upload
        </button>
        <input
          (change)="inputImageFile($event)"
          type="file"
          accept="image/*"
          hidden
          #stickerUpload
        />
      </div>
    </mat-tab>
    <mat-tab label="AI Maker">
      <div class="w-full flex flex-col gap-1">
        <textarea
          class="w-full resize-none text-[10px] lg:text-sm dark:text-white p-1 bg-black/5 dark:bg-white/20 rounded"
          [rows]="5"
          [formControl]="promptForm"
          [placeholder]="'Enter your livery design prompt.'"
        ></textarea>
        <button
          class="w-full px-1.5 lg:px-3 py-0.5 lg:py-1 rounded bg-sky-700 text-white text-[10px] lg:text-sm"
          (click)="onSendAi()"
        >
          Create
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>

  <p class="text-xs lg:text-base text-white font-semibold mb-1 lg:mb-2">Stickers</p>
  <div class="relative w-full flex flex-row">
    <button
      class="w-full px-2 lg:px-4 py-1 lg:py-2 text-[0.625rem] lg:text-xs border border-r-0 rounded-l text-black"
      [ngClass]="{
        'bg-white': selectedStickerListTypeIndex === 0,
        'bg-slate-300 dark:bg-black dark:text-white': selectedStickerListTypeIndex !== 0,
      }"
      (click)="selectedStickerListTypeIndex = 0"
    >
      Default
    </button>
    <button
      class="w-full px-2 lg:px-4 py-1 lg:py-2 text-[0.625rem] lg:text-xs border rounded-r text-black"
      [ngClass]="{
        'bg-white': selectedStickerListTypeIndex === 1,
        'bg-slate-300 dark:bg-black dark:text-white': selectedStickerListTypeIndex !== 1,
      }"
      (click)="selectedStickerListTypeIndex = 1"
    >
      History
    </button>
  </div>
  <mat-tab-group class="py-2 mb-1 lg:mb-2" [selectedIndex]="selectedStickerListTypeIndex">
    <mat-tab class="relative w-full h-full py-2" label="Default">
      <mat-grid-list [cols]="width > 300 ? 4 : 2" rowHeight="1:1" gutterSize="5px">
        @for (defaultSticker of defaultStickers; track defaultSticker) {
          <mat-grid-tile
            class="bg-black/10 dark:bg-white/20 rounded cursor-pointer overflow-hidden"
            [colspan]="defaultSticker.type == 'livery' ? 2 : 1"
            (click)="onClickSelectSticker(defaultSticker)"
          >
            <img
              class="w-full h-full object-contain object-center"
              [src]="defaultSticker.image"
              alt="sticker"
            />
          </mat-grid-tile>
        }
      </mat-grid-list>
    </mat-tab>
    <mat-tab class="relative w-full h-full py-2" label="History">
      <mat-grid-list [cols]="width > 300 ? 4 : 2" rowHeight="1:1" gutterSize="5px">
        @for (historySticker of historyStickers; track historySticker) {
          <mat-grid-tile
            class="bg-black/10 dark:bg-white/20 rounded cursor-pointer overflow-hidden"
            [colspan]="historySticker.type == 'livery' ? 2 : 1"
            (click)="onClickSelectSticker(historySticker)"
          >
            <img
              class="w-full h-full object-contain object-center"
              [src]="historySticker.image"
              alt="sticker"
            />
          </mat-grid-tile>
        }
      </mat-grid-list>
    </mat-tab>
  </mat-tab-group>
</div>

<livery-editor-tool
  class="transition-all transform duration-150 ease-in-out"
  [editStickerIndex]="selectedAttachedStickerIndex"
  (endEditor)="initEditor()"
  [ngClass]="{
    'top-0 left-0 lg:top-0 lg:left-0 opacity-100': selectedAttachedStickerIndex >= 0,
    'top-0 left-full opacity-0': selectedAttachedStickerIndex < 0 && width <= 300,
    'top-full left-0 lg:top-0 lg:left-full opacity-0':
      selectedAttachedStickerIndex < 0 && width > 300,
  }"
></livery-editor-tool>
<livery-attach-tool
  class="transition-all transform duration-150 ease-in-out"
  [attachSticker]="attachSticker"
  [width]="width"
  (endAttach)="initAttachSticker()"
  [ngClass]="{
    'top-0 left-0 lg:top-0 lg:left-0 opacity-100': attachSticker,
    'top-0 left-full opacity-0': !attachSticker && width <= 300,
    'top-full left-0 lg:top-0 lg:left-full opacity-0': !attachSticker && width > 300,
  }"
></livery-attach-tool>
